import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Card from "react-bootstrap/Card";
import "./Banner.scss"
import { faGear, faRepeat, faUserGroup } from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  success: faGear,
  error: faRepeat,
  warning: faUserGroup,
};

function Banner({variant = "warning", message, icon}) {
  const getIcon = () => {
    return <FontAwesomeIcon icon={iconMap[variant]} className="card-icon" />
  }
  return <Card body className={`custom-card ${variant} ml-2`}>
    {icon && <span>{getIcon()}</span>}{message}
  </Card>;
}

export default Banner;